import React from 'react';
import { Link } from "react-router-dom";
import Footer from '../../footer';
import Header from '../../header/header';
import Navvbar from '../../header/Navvbar';



const linkStyle = {
  textDecoration: 'none',
  color: '#004aad',
};

const headingStyle = {
  fontSize: '1.1rem',
  fontWeight: 'bold',
  marginLeft:"5px",
  marginBottom: "0",  // Remove margin from the bottom of the heading
};

const paragraphStyle = {
  color: '#6c757d',
  marginLeft:"20px",
  marginTop: "0", // Remove top margin of paragraph
  marginBottom: "0",  // Remove bottom margin of paragraph
};


const PromotionOverview = () => { 
  return (
    <>
      <Header/>
      <Navvbar/>
      <br/>
      <div style={{width: '95%',  margin: '0 auto' ,padding:"0px"}}>
          <div className="col-md-10">
            <div className="main-content">
              <h2>Promotional Tools</h2>
              <div className="setting">
                <Link to="/website" style={linkStyle}>
                  <h6 style={headingStyle}>DDX Websites</h6>
                </Link>
                <p style={paragraphStyle}>Customize your DDX website with your logo, company overview, and services offered.</p>
              </div>
              <div className="setting">
                <Link to="/ddxAdd" style={linkStyle}>
                  <h6 style={headingStyle}>DDX Ads</h6>
                </Link>
                <p style={paragraphStyle}>Create DDX Ads to promote your lab.</p>
              </div>
              <div className="action">
                <Link to="/coupon" style={linkStyle}>
                  <h6 style={headingStyle}>DDX Coupons</h6>
                </Link>
                <p style={paragraphStyle}>Create DDX coupons to allow for discounts and encourage sales of new procedures.</p>
              </div>

              <div className="action">
                <Link to="/action" style={linkStyle}>
                  <h6 style={headingStyle}>Links</h6>
                </Link>
                <p style={paragraphStyle}>Custom DDX links to place on websites to drive traffic to your DDX lab.</p>
              </div>

              <div className="action">
                <Link to="/widgets" style={linkStyle}>
                  <h6 style={headingStyle}>Widgets</h6>
                </Link>
                <p style={paragraphStyle}>HTML widgets for your DDX lab to place on your website.</p>
              </div>

              <div className="action">
                <Link to="/ddxAccount" style={linkStyle}>
                  <h6 style={headingStyle}>DDX Account Onboarding</h6>
                </Link>
                <p style={paragraphStyle}>Features related to new DDX account onboarding.</p>
              </div>
            </div>
          </div>
      </div>
      <br/><br/><br/><br/><br/><br/><br/><br/><br/><br/><br/><br/><br/><br/><br/><br/><br/><br/><br/><br/>
      <div style={{width: '95%',  margin: '0 auto' ,padding:"0px"}}>
        <Footer/>
      </div>
    </>
  );
}

export default PromotionOverview;
